import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  PathPickOrderUpdateRequestBody,
  pathPickOrderHistoryMutationApi,
} from "@/features/pathpick/features/order-history/api/mutation";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 주문 수정(입금자명/배송지) — 성공 시 목록·상세를 한 번에 무효화한다
// (두 훅이 ["pathpick", "orders", companyId] 프리픽스를 공유한다).
// 성공 안내 UI는 호출부가 담당한다.
const useUpdatePathPickOrder = (orderId: number) => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: (body: PathPickOrderUpdateRequestBody) =>
      pathPickOrderHistoryMutationApi.updatePathPickOrder(
        companyId as number,
        orderId,
        body
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["pathpick", "orders", companyId],
      });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useUpdatePathPickOrder;
